import React from 'react';
import { useField } from 'formik';

import { FloatingInput } from '../../FormComponents';

const FormikFloatingInput = (props) => {
  const [field] = useField(props);
  const { onChange } = field;

  const newHandleChange = (val) => {
    if (props.disabled) return;
    onChange({ target: { name: props.name, value: val } });
  };

  const { placeholder, ...newProps } = props;

  return (
    <FloatingInput {...{ ...field, onChange: newHandleChange }} {...newProps} />
  );
};

export default FormikFloatingInput;
